<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else class="form-customer">
    <h1 class="text-center">Search Web POS Customer</h1>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label for="firstName">Firstname </label>
        <input
          id="firstName"
          type="text"
          v-model="firstName"
          class="form-control"
        />
        <div v-if="isSubmit && $v.firstName.$invalid" class="text-error">
          กรุณากรอกชื่อให้ครบถ้วน
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label for="lastName">Lastname </label>
        <input
          id="lastName"
          type="text"
          v-model="lastName"
          class="form-control"
        />
        <div v-if="isSubmit && $v.lastName.$invalid" class="text-error">
          กรุณากรอกนามสกุลให้ครบถ้วน
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label for="mobileInput">Mobile </label>
        <input
          id="mobileInput"
          type="text"
          v-model="mobile"
          class="form-control"
        />
        <div v-if="isSubmit && $v.mobile.$invalid" class="text-error">
          กรุณากรอกเบอร์โทรศัพท์
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label for="posCustomerId">Web POS customer ID </label>
        <input
          id="posCustomerId"
          type="text"
          v-model="posId"
          class="form-control"
          disabled
        />
        <div v-if="isSubmit && $v.posId.$invalid" class="text-error">
          ห้ามแก้ไขข้อมูล
        </div>
      </div>
    </div>
    <div class="group-btn-submit">
      <button
        class="btn btn-outline-danger"
        @click="() => $router.push({ name: 'PosCustomer' })"
        style="margin-right: 1rem">
        Cancel
      </button>
      <button class="btn btn-outline-success" @click="submitForm">Save</button>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="text-center">
          <div v-if="showSuccess && id">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess">
            <button
              class="btn-back"
              @click="() => $router.push({ name: 'PosCustomer' })">
              กลับสู่หน้าหลัก
            </button>
          </div>
          <button
            v-if="!showSuccess"
            class="btn-back"
            @click="showDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import CustomerService from "@/services/api/poscustomer.service.js";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      id: this.$route.query.id,
      firstName: "",
      lastName: "",
      mobile: "",
      posId: "",
      isSubmit: false,
    };
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    mobile: {
      required,
    },
    posId: {
      required,
    },
  },
  mounted() {
    this.getDetail(this.id);
  },
  methods: {
    async getDetail(id) {
      this.isLoading = true;
      try {
        await CustomerService.getDetailCustomer(id)
          .then((res) => {
            const data = res.data;
            const value = data.existingCustomer;
            this.firstName = value.firstName;
            this.lastName = value.lastName;
            this.mobile = value.mobile;
            this.posId = value.id;
            this.isLoading = false;
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async submitForm() {
      const validate = this.$v;
      this.isSubmit = true;
      if (validate.$invalid) {
        return;
      }
      this.isLoading = true;
      this.showSuccess = false;
      const body = {
        firstName: this.firstName,
        lastName: this.lastName,
        mobile: this.mobile,
      };
      try {
        await CustomerService.updateCustomer(this.id, body)
          .then(() => {
            this.isLoading = false;
            this.showDialog = true;
            this.showSuccess = true;
            this.message = "บันทึกสำเร็จ";
          })
          .catch((err) => {
            this.isLoading = false;
            this.showDialog = true;
            this.showSuccess = false;
            this.message = "ไม่สามารถบันทึกได้";
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        this.showDialog = true;
        this.showSuccess = false;
        this.message = "ไม่สามารถบันทึกได้";
        console.log("Error: ", error);
      }
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.group-btn-submit {
  padding: 3rem 0;
  display: flex;
  justify-content: flex-end;
}
</style>
